import Routes from './Routes';
export { protectedRoutes, publicRoutes } from './configs';

export default Routes;
